module.exports = __webpack_public_path__ + "media/images/weather/111_night-02f54e3313e12c319f677594f61fac1d.png";